import { render, staticRenderFns } from "./LexinKeyboardLangTam.vue?vue&type=template&id=24e6c6ee&"
import script from "./LexinKeyboardLangTam.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangTam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports